import { QuilttProvider } from '@quiltt/react';

import type { ContainerComponent } from '../../common/types/Common';
import useGetQuilttSession from '../hooks/useGetQuilttSession';

const QuilttSessionProvider: ContainerComponent = ({ children }) => {
    const { data: quilttSession } = useGetQuilttSession();

    return (
        <QuilttProvider token={quilttSession ?? undefined}>
            {children}
        </QuilttProvider>
    );
};

export default QuilttSessionProvider;
